import { Buffer } from 'buffer';
declare var global: any;
(window as any).global = window;
global.Buffer = Buffer;
global.process = {
    env: { DEBUG: undefined },
    version: ''
} as any;
/***************************************************************************************************
* SCULLY IMPORTS
*/
// tslint:disable-next-line: align
// Load task-tracking only during development for debugging async tasks
// Note: task-tracking import removed for Angular 18 compatibility
